// extracted by mini-css-extract-plugin
export default {"image":"ImageContainer_image__4Wuo5"};